import { Bet } from "src/types";
import { getLocale } from "src/utils";

export const getBalances = (bets: Array<Bet>) => {
  const result: Array<{ amount: string; id: number }> = [];

  const balancesById = bets.reduce(
    (all, { amount, balanceId }) => ({
      ...all,
      [balanceId]: amount + (all[balanceId] || 0),
    }),
    {} as Record<number, number>
  );

  for (const balanceId in balancesById) {
    const balance = balancesById[balanceId];

    if (balance) {
      const id = +balanceId;
      const amount = getLocale(balance, id);
      result.push({ amount, id });
    }
  }
  return result;
};
